export const GUARDAR_TOMA_FISICA = 'GUARDAR_TOMA_FISICA';
export const GUARDAR_TOMA_FISICA_EXITO = 'GUARDAR_TOMA_FISICA_EXITO';
export const GUARDAR_TOMA_FISICA_ERROR = 'GUARDAR_TOMA_FISICA_ERROR';